import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import TaxonomyCodeIcon from "../../../assets/images/svg-icons-material-io/link_FILL0_wght400_GRAD0_opsz48.svg";
import MonitorIcon from "../../../assets/images/svg-icons-material-io/screenshot_monitor_FILL0_wght400_GRAD0_opsz48.svg";
import BulkUploadTemplate from "../../../assets/images/bulkUploadimg.png";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import fileDownload from "js-file-download";
import CreateFilenameModal from "../../upload-status/CreateFilenameModal";
import { UploadType } from "../../../utils/enums";

const obj = {
  VendorId: 0,
  OrganizationId: 0,
  OrganizationName: "",
  UploadOption: "Add",
  UserSubmitFile: "",
  isSendNotification: false,
};
const FormUserUpload = () => {
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [processing, SetProcessing] = useState(false);
  const [submitFlag, SetSubmitFlag] = useState(false);
  const [errFlag, SetErrFlag] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [orgObj, SetOrgObj] = useState([]);
  const [custObject, SetCustObject] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [trustedAgent, setTrustedAgent] = useState(false);
  const [uploadType, setUploadType] = useState("Add");
  const fileInputRef = useRef(null);

  useEffect(() => {
    const temp = [];
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      temp.push(el);
    }
    SetCustObject(temp);
    SetSharedObject("specialties", {});
    SetSubmitFlag(false);
    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      const temp = [];
      for (let el of sharedObject.getOrgsObj) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      getUser(userSession.sesuser_id);
    }
  }, []);
  const getUser = async (id) => {
    let TrustedAgent = false;
    setTrustedAgent(false);
    SetProcessing(true);
    let call = "/users/getUserById?userId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data;
      TrustedAgent = det.userContact.trustedAgent;
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
      TrustedAgent = false;
    }
    if (!TrustedAgent) {
      setAnswers((prev) => ({
        ...prev,
        isSendNotification: true,
      }));
      setTrustedAgent(true);
    }
  };
  const setAnswer = async (questionId, answer, chck) => {
    if (questionId === "UploadOption") {
      setUploadType(answer);
    }
    setAnswers((prev) => ({
      ...prev,
      [questionId]: answer,
    }));
  };

  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(true);
    }
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };

  const downTemplate = async (url) => {
    SetProcessing(true);
    const res = await CallAPI(url, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let fileName = "SescsvBulkUploadTemplate.csv";
      fileDownload(res.data, fileName);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(true);
    }
  };

  const initiateUpload = () => {
    const fileInput = fileInputRef.current;
    const file = fileInput.files[0];
    let o = {
      UploadType: UploadType.AddUsers,
      UploadFile: file,
      OrganizationId: answers.OrganizationId,
      UploadOption: answers.UploadOption,
      isSendNotification: answers.isSendNotification,
    };
    SetSharedObject("UploadStausObj", o);
  };

  const triggerValidation = (el) => {
    var regex = new RegExp("(.*?).(csv)$");
    if (!regex.test(el.target.value.toLowerCase())) {
      SetErrFlag(true);
    } else {
      setAnswer("UserSubmitFile", el);
      SetErrFlag(false);
    }
  };
  const getDomain = (url) => {
    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }
    return url;
  };
  const openImg = () => {
    let url = getDomain(window.location.hostname);
    if (url === "localhost") {
      window.open(BulkUploadTemplate);
    } else {
      window.open(BulkUploadTemplate);
    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <div className="FormUserUpload">
      <form className="sp-pad1" aria-labelledby="bulkUploadTitle">
        {/*Left Panel*/}
        <div className="left-panel-s1">
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <div className="field-wrapper">
              <label htmlFor="VendorId">Customer</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  aria-label="Filter customers"
                  onChange={(el) => {
                    filterVendors(el.target.value);
                  }}
                />
              </span>
              <select
                className="form-control"
                size="5"
                id="VendorId"
                name="VendorId"
                required
                aria-required="true"
                aria-invalid={submitFlag && answers?.VendorId === 0}
                aria-describedby={submitFlag && answers?.VendorId === 0 ? "VendorIdError" : undefined}
                onChange={(el) => {
                  CustomerIdSet(el.target.value);
                  setAnswer("VendorId", parseInt(el.target.value));
                }}
                value={answers?.VendorId}
              >
                <option value={0}>Select Customer</option>
                {custObject?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {submitFlag && answers?.VendorId === 0 ? (
                <div className="alert alert-danger" id="VendorIdError" role="alert">
                  Customer is required.
                </div>
              ) : null}
            </div>
          )}
          <div className="field-wrapper">
            <label htmlFor="OrganizationId">Organization</label>
            <span className="filter-container dg-clr">
              <input
                className="form-control filter-sm"
                type="search"
                placeholder="Filter"
                aria-label="Filter organizations"
                onChange={(el) => filterOrganiations(el.target.value)}
              />
            </span>

            {orgObj.length > 0 ? (
              <select
                className="form-control"
                size="5"
                name="OrganizationId"
                id="OrganizationId"
                required
                aria-required="true"
                aria-invalid={answers?.OrganizationId === 0 && submitFlag}
                aria-describedby={answers?.OrganizationId === 0 && submitFlag ? "OrganizationIdError" : undefined}
                onChange={(el) => {
                  setAnswer("OrganizationId", parseInt(el.target.value));
                }}
                value={answers?.OrganizationId}
              >
                <option value={0}>Select Organization</option>
                {orgObj?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={`${el.id}`}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
            ) : (
              <div className="watermark-wrapper">No Results</div>
            )}

            {answers?.OrganizationId === 0 && submitFlag ? (
              <div className="alert alert-danger" id="OrganizationIdError" role="alert">
                Organization is required.
              </div>
            ) : null}
          </div>
          <div className="field-wrapper">
            <label htmlFor="UploadOption" className="spacer-margin5">
              Do you want to add or delete users?
            </label>
            <select
              className="form-control w-lg4 spacer-inline"
              name="UploadOption"
              id="UploadOption"
              onChange={(el) => {
                setAnswer("UploadOption", el.target.value);
              }}
              value={answers?.UploadOption}
            >
              <option value="Add">Add</option>
              <option value="Delete">Delete</option>
            </select>
          </div>
          <div className="field-wrapper">
            <label htmlFor="UserSubmitFile">Select CSV file</label>
            <div className="form-group">
              <input
                type="file"
                className="form-control-file  cblu-clr "
                id="UserSubmitFile"
                ref={fileInputRef}
                required
                aria-required="true"
                aria-invalid={errFlag || (answers?.UserSubmitFile === "" && submitFlag)}
                aria-describedby={
                  errFlag
                    ? "UserSubmitFileTypeError"
                    : answers?.UserSubmitFile === "" && submitFlag
                    ? "UserSubmitFileRequiredError"
                    : undefined
                }
                accept=".csv"
                onChange={(el) => {
                  triggerValidation(el);
                }}
              />
            </div>
            {errFlag ? (
              <div className="alert alert-danger" id="UserSubmitFileTypeError" role="alert">
                The file you are trying to upload is not a CSV file. Please try
                again using a proper file type with a .csv file extension. You
                can also download our template and view our sample below.
              </div>
            ) : null}
            {answers?.UserSubmitFile === "" && submitFlag ? (
              <div className="alert alert-danger" id="UserSubmitFileRequiredError" role="alert">
                CSV file is required.
              </div>
            ) : null}

            <aside className="filelist-items">
              <p>
                The MS Excel spreadsheet must be saved as a CSV format that
                contains a .csv extension and rename the file if you intend to
                upload it again.
              </p>
              If a duplicate Username is entered, a unique number will be added
              to the Username (i.e. DrSmith - DrSmith1).
            </aside>
          </div>
          {/*Email Notify Flag*/}
          {answers?.UploadOption !== "Delete" && (
            <div className="field-wrapper">
              <label htmlFor="EmailNotification">Email Notifications:</label>
              <input
                className="form-control"
                name="EmailNotification"
                id="EmailNotification"
                type="checkbox"
                onChange={(el) => {
                  setAnswer("isSendNotification", el.target.checked);
                }}
                disabled={trustedAgent}
                checked={answers?.isSendNotification}
                value={answers?.isSendNotification}
              />
              <aside className="filelist-items">
                If selected, a confirmation email will be sent to the provided
                contact email address for each successfully created account,
                containing the user's ID and a temporary password. If not
                selected, new users created during the upload process will not
                receive their account information and will be unable to access
                the site and webmail.
              </aside>
            </div>
          )}

          {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="loader-id"
            >
              <div className="spinner" aria-hidden="true"></div>
              <div className="loading-text" id="loader-id">{loadingText}</div>
            </div>
          )}
          {/*Upload Action*/}
          <div className="button-register-container">
            <button
              type="button"
              className="btn btn-success"
              disabled={errFlag}
              onClick={() => {
                SetSubmitFlag(true);
                if (answers?.UserSubmitFile !== "") {
                  if (answers?.UploadOption === "Delete") {
                    setShowDeleteModal(true);
                  } else {
                    initiateUpload();
                    $("#createFilenameModal").modal("show");
                  }
                }
              }}
            >
              Upload
            </button>
            <Link
              type="button"
              className="btn btn-outline-secondary spacer-margin2"
              to="/Users"
              aria-label="Cancel and return to Users"
            >
              Cancel
            </Link>
          </div>
          {/*User helpful templates */}
          <div className="box-template">
            <Link
              onClick={(el) => {
                downTemplate("/users/DownloadCsvTemplate");
                el.preventDefault();
              }}
              className="btn btn-primary box-containers box-sentmsg"
              to="#"
              aria-label="Download CSV File Template"
              type="button"
            >
              <div className="box-icon">
                <i className="bi bi-download" aria-hidden="true"></i>
                <span className="sr-only">Download CSV File Template</span>
              </div>
              <div className="box-bottom">
                <div className="title">CSV File Template</div>
              </div>
            </Link>
            <a
              href="https://www.nucc.org/index.php?option=com_content&view=article&id=107&Itemid=132"
              target="_blank"
              className="btn btn-primary box-containers box-status"
              rel="noreferrer"
              aria-label="NUCC Taxonomy Codes (opens in new tab)"
            >
              <div className="box-icon">
                <img
                  src={TaxonomyCodeIcon}
                  className="filter-white"
                  alt=""
                  aria-hidden="true"
                />
                <span className="sr-only">NUCC Taxonomy Codes</span>
              </div>
              <div className="box-bottom">
                <div className="title">NUCC Taxonomy Codes</div>
              </div>
            </a>
            <Link
              onClick={openImg}
              target="_blank"
              className="btn btn-primary box-containers box-reports"
              to="#"
              aria-label="Sample CSV Template Screenshots"
              type="button"
            >
              <div className="box-icon">
                <img
                  src={MonitorIcon}
                  className="filter-white"
                  alt=""
                  aria-hidden="true"
                />
                <span className="sr-only">Sample CSV Template Screenshots</span>
              </div>
              <div className="box-bottom">
                <div className="title">
                  Sample <br />
                  CSV File Screenshots
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/*Right Panel*/}
        <div className="right-panel-s1">
          {/*Requirement Rules*/}
          <div className="field-wrapper label-hd-divider" id="requirementsTitle">Requirements</div>
          {uploadType === "Add" ? (
            <>
              <div className="field-wrapper">
                <div className="text-reg spacer-margin7">
                  The following list of items are required and must be included in
                  your file.
                </div>
                <ul className="filelist-items" aria-labelledby="requirementsTitle">
                  <li>
                    <span className="ft-wt blk-clr">User Type:</span> Always enter
                    Professional with exact case and characters
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">First Name:</span> 20 character
                    limit
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Last Name:</span> 35 character
                    limit
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Contact Email:</span> Non Direct
                    email address
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Username:</span> Username to
                    login to the system
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Address 1:</span> 100 character
                    limit
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">City:</span> 50 character limit
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">State:</span> State Abbreviation
                    - 2 character limit - Uppercase Only
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Zip Code:</span> 5 character
                    limit
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Phone Number:</span> Use
                    xxxxxxxxxx format
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">
                      Requested Direct Address:{" "}
                    </span>
                    Must include the full Direct Address including domain
                  </li>
                </ul>
              </div>

              {/*Optional Rules*/}
              <div className="field-wrapper label-hd-divider">Optional</div>
              <div className="field-wrapper">
                <div className="text-reg spacer-margin7">
                  The following list of items are your options to include in your
                  file.
                </div>
                <ul className="filelist-items">
                  <li>
                    <span className="ft-wt blk-clr">Address 2:</span> 100 character
                    limit
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Prefix:</span> Enter Ms, Mr,
                    Miss, Mrs, Dr, or Prof with exact case and characters
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Credential:</span> Enter
                    credential with case and characters (M.D. or MD, etc.) - If you
                    have more than one credential, please insert a space in between
                    the credentials.
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">Fax Number:</span> Use
                    xxxxxxxxxx format
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">
                      NPI (National Provider ID):{" "}
                    </span>
                    Must be a 10 digit number (Use xxxxxxxxxx format)
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">License Number:</span> Medical
                    License Number - If you have more than one Medical License,
                    additional Licenses can be added within the portal. If you enter
                    your License Number, State of License is required.
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">State of License:</span> State
                    of Medical License - 2 character limit - Uppercase Only - If you
                    enter your State of License, License Number is required.
                  </li>
                  <li>
                    <span className="ft-wt blk-clr">NUCC Taxonomy:</span> Input the
                    code found in the current version of the National Uniform Claim
                    Committee Health Care Provider Taxonomy Code Set
                  </li>
                </ul>
              </div>
            </>
          ) : (
            <>
              <div className="text-reg spacer-margin7">
                The following steps are required to delete users
                successfully.
              </div>
              <ul className="filelist-items">
                <li>Use the same user upload template</li>
                <li>Provide the required user information</li>
                <li>Upload with a different filename</li>
              </ul>
            </>
          )}
        </div>
      </form>
      <CreateFilenameModal />
      <DeleteConfirmationModal
        show={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        onConfirm={() => {
          setShowDeleteModal(false);
          initiateUpload();
          $("#createFilenameModal").modal("show");
        }}
      />
    </div>
  );
};

const DeleteConfirmationModal = ({ show, setShowDeleteModal, onConfirm }) => {
  const [visible, setVisible] = useState(show);
  const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      setVisible(true);
      setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.focus();
        }
      }, 100);
    } else {
      const timeout = setTimeout(() => setVisible(false), 150);
      return () => clearTimeout(timeout);
    }
  }, [show]);

  if (!visible) return null;

  // Combined close handler
  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $('#UploadUserDeleteModal').modal('hide');
    setShowDeleteModal(false); // Update parent state to unmount modal
  };

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="DeleteModalTitle"
        aria-describedby="DeleteModalDesc"
        id="UploadUserDeleteModal"
        style={{ display: show ? "block" : "none" }}
        data-backdrop="static"
        ref={modalRef}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="DeleteModalTitle">
                Delete Confirmation
              </h3>
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" id="DeleteModalDesc">
              <div className="alert-warning-o">
                <i className="bi bi-exclamation-circle" aria-hidden="true"></i>
                <span className="sr-only">Alert</span>
              </div>
              <div className="message-wrapper">
                Are you sure you want to permanently delete all the users?
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-success"
                onClick={onConfirm}
                type="button"
              >
                Confirm
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={CloseModal}
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal-backdrop fade ${show ? "show" : ""}`}></div>
    </>
  );
};

export default FormUserUpload;
